<div class="chat-input-box">
  <!-- Выбор файла (документа) для вложения в сообщение -->
  <div>
    <chat-attachment [messageText]="newMessage" (attachmentConfirmed)="sendAttachments($event)"></chat-attachment>
    <!-- <app-emoji-button (emojiClicked)="insertEmoji($event)"></app-emoji-button> -->
  </div>

  <!-- Поле ввода сообщения -->
  <message-input
    [(message)]="newMessage"
    [floatingToolbar]="!isMobile"
    [invalid]="isInputAreaInvalid"
    [placeholder]="'components.internalMessenger.fields.writeMessage' | translate"
    (onEnterKeyPressed)="sendTextMessage()"
  ></message-input>

  <div>
    <!-- Отправить сообщение -->
    <button
      tuiIconButton
      class="chat-input-box__send-button"
      type="button"
      appearance="icon"
      size="s"
      (click)="sendTextMessage()"
    >
      <app-icon src="send"></app-icon>
    </button>
  </div>
</div>
